import type {
  ValidationRule,
  ValidationRuleModule,
  ValidationRuleValidator,
} from '../types'

/**
 * Factory function for creating validation rules
 *
 * It reduces the amount of boilerplate by providing the guards and define functions
 *
 * @param param0
 * @returns
 */
type CreatedRule<RULE extends ValidationRule> = ValidationRule<
  RULE['ruleName'],
  RULE['ruleConfig']
>

export function createRuleHandler<RULE extends ValidationRule>({
  ruleName,
  validate,
  messages,
}: {
  ruleName: RULE['ruleName']
  validate: ValidationRuleValidator<CreatedRule<RULE>>
  messages: RULE['messages']
}): ValidationRuleModule<CreatedRule<RULE>> {
  return {
    ruleName,

    canHandle(obj: unknown): obj is CreatedRule<RULE> {
      return (
        !!obj &&
        typeof obj === 'object' &&
        'ruleName' in obj &&
        obj.ruleName === ruleName
      )
    },

    define(args: RULE['ruleConfig'], overrides = {}): CreatedRule<RULE> {
      const generic = overrides.messages?.generic || messages.generic
      const specific = overrides.messages
        ? overrides.messages.specific || generic
        : messages.specific || generic
      return {
        ruleName,
        ruleConfig: args,
        messages: {
          generic,
          specific,
        },
      }
    },

    validate,
  }
}
